export enum AccountOwnership {
	DIFFERENT,
	SAME
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/models/account-ownership.enum.ts